import { type PropsWithChildren, PureComponent } from 'react';
import { connect } from 'react-redux';

type TStateSlice = {
  theme: { className: string };
};

type MainWrapperProps = PropsWithChildren<{
  theme: { className: string };
}>;

class MainWrapper extends PureComponent<MainWrapperProps> {
  render() {
    return (
      <div className={this.props.theme.className}>
        <div className='wrapper'>{this.props.children}</div>
      </div>
    );
  }
}

export default connect((state: TStateSlice) => ({
  theme: state.theme,
}))(MainWrapper);
